import { BUSINESS_TOOL_MODE } from 'constants/businessTool';
import { ONE_PAGE_DISPLAY_MODE } from 'layouts/OnePagePreviewLayout';
import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';

import { IBusinessToolSessionStore } from './types';

export const useBusinessToolSessionStore = create<IBusinessToolSessionStore>()(
  persist(
    (set) => ({
      businessToolMode: BUSINESS_TOOL_MODE.EDIT,
      setBusinessToolMode: (mode) => set({ businessToolMode: mode }),

      onePageDisplayMode: ONE_PAGE_DISPLAY_MODE.PROJECT,
      setOnePageDisplayMode: (mode) => set({ onePageDisplayMode: mode }),
    }),
    {
      name: 'business-tool-session-storage',
      storage: createJSONStorage(() => sessionStorage),
    },
  ),
);
